import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import type { IconName } from '@/components/common/Icon';

export interface AdminNavigationItem {
  id: string;
  labelKey: string;
  route: string;
  iconName: IconName;
  requiredPermission: string | null;
  requiredAnyPermission?: string[];
  unreadBadge?: boolean;
}

export function isAdminNavigationItemVisible(
  item: AdminNavigationItem,
  platformPermissions: string[]
): boolean {
  if (item.requiredAnyPermission !== undefined) {
    return item.requiredAnyPermission.some(function isPermissionGranted(permissionCode) {
      return platformPermissions.includes(permissionCode);
    });
  }
  if (item.requiredPermission === null) {
    return true;
  }
  return platformPermissions.includes(item.requiredPermission);
}

export const ADMIN_NAVIGATION_ITEMS: AdminNavigationItem[] = [
  {
    id: 'dashboard',
    labelKey: 'navigation.dashboard',
    route: APPLICATION_ROUTES.adminDashboard,
    iconName: 'LayoutDashboard',
    requiredPermission: null,
  },
  {
    id: 'practitioners',
    labelKey: 'navigation.practitioners',
    route: APPLICATION_ROUTES.adminPractitioners,
    iconName: 'Building',
    requiredPermission: null,
  },
  {
    id: 'accessControl',
    labelKey: 'navigation.accessControl',
    route: APPLICATION_ROUTES.adminAccessControl,
    iconName: 'ShieldCheck',
    requiredPermission: null,
    requiredAnyPermission: ['user.read_all', 'role.read_all', 'audit.read_all'],
  },
  {
    id: 'support',
    labelKey: 'navigation.support',
    route: APPLICATION_ROUTES.adminSupport,
    iconName: 'Ticket',
    requiredPermission: 'support_admin.read_all',
    unreadBadge: true,
  },
  {
    id: 'assistant',
    labelKey: 'navigation.assistant',
    route: APPLICATION_ROUTES.adminAssistant,
    iconName: 'Sparkles',
    requiredPermission: null,
    requiredAnyPermission: ['assistant_usage.read', 'assistant_configuration.read'],
  },
  {
    id: 'notifications',
    labelKey: 'navigation.notifications',
    route: APPLICATION_ROUTES.adminNotifications,
    iconName: 'Bell',
    requiredPermission: null,
  },
];
